import * as actionTypes from './actionType';
import { I_AllFilter, I_AllFilterSelected, I_AllCards } from './interface';

const AllFilterStore = <I_AllFilter>{
    PriceMax: 1,
    PriceMin: 0,
    DestinationList: [],
    TravelPlanList: [
        { value: 'grp', text: '團體' },
        { value: 'htl', text: '訂房' },
        { value: 'vac', text: '自由行' },
        { value: 'etk', text: '票券' },
        { value: 'flt', text: '機票' },
    ],
    LightboxDestination: [],
};
const AllFilterSelected = <I_AllFilterSelected>{
    // Keyword: '日本',
    selectedPrices: [],
    selectedDestinationID: [],
    selectedProductType: ['grp', 'vac', 'htl', 'etk', 'flt'],
    Page: 1,
    PageSize: 10,
    SortType: '',
};

const All = {
    AllFilterStore,
    AllFilterSelected,
};
export const AllReducer = (state = All, action: any) => {
    switch (action.type) {
        case actionTypes.SET_ALL_SUCCESS:
            return { ...state, AllFilterStore: { ...state.AllFilterStore, ...action.payload } };
        // return { ...state, [action.payload.filterTag]: action.payload };
        case actionTypes.SET_ALL_SELECTED: // 傳入 { datafilter的key : 選到的值 }
            return {
                ...state,
                AllFilterSelected: { ...state.AllFilterSelected, ...action.payload },
            };
        case actionTypes.SET_ALL_LIGHTBOXDEST: //光箱所有目的地
            return {
                ...state,
                AllFilterStore: { ...state.AllFilterStore, ...action.payload },
            };

        default:
            return state;
    }
};
